import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Inject,
  HostListener,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { find } from "lodash";
import {
  MatDialog,
  MatSlideToggleChange,
  MatSnackBar,
} from "@angular/material";
import * as moment from "moment";
import { RegraFreteService } from "../../services/regra-frete.service";
import { ModalComponent } from "../../components/modal/modal.component";
import { Router } from "@angular/router";
import { ModalConfirmComponent } from "../../components/confirm/modal.component";

@Component({
  selector: "mandae-regra-frete-criar",
  templateUrl: "./criar-regra-frete.component.html",
  styleUrls: ["./criar-regra-frete.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegraFreteCriarComponent implements OnInit {
  public formulario: FormGroup;

  public calculoPercentual = "positivo";

  public calculoValorFixo = "";

  public readonly acoes = [
    {
      nome: "Acrescentar um percentual ao frete",
      value: "ALTERA_PERCENTUAL",
      tipo: "positivo",
      obrigatorio: true,
    },
    {
      nome: "Acrescentar um valor fixo ao frete",
      value: "ALTERA_VALOR_FIXO",
      tipo: "positivo",
      obrigatorio: true,
    },
    {
      nome: "Subtrair um percentual do frete",
      value: "ALTERA_PERCENTUAL",
      tipo: "negativo",
      obrigatorio: true,
    },
    {
      nome: "Subtrair um valor fixo do frete",
      value: "ALTERA_VALOR_FIXO",
      tipo: "negativo",
      obrigatorio: true,
    },
    {
      nome: "Fixar o preço do frete",
      value: "FIXA_VALOR",
      tipo: "positivo",
      obrigatorio: true,
    },
    { nome: "Definir frete grátis", value: "FRETE_GRATIS", obrigatorio: false },
    {
      nome: "Adicionar dias ao prazo",
      value: "ALTERA_PRAZO",
      tipo: "positivo",
      obrigatorio: true,
    },
    {
      nome: "Excluir modalidade",
      value: "EXCLUIR_MODALIDADE",
      obrigatorio: false,
    },
  ];

  public necessitaPreencher = false;

  public labelValorAcao = null;

  public mascara = null;

  public condicoes = {};

  public dataAtual = new Date();

  public condicoesErro = {
    peso: false,
    pesoCubado: false,
    valor: false,
    faixaCep: false,
    estados: false,
    faixaCepOrigem: false,
    estadosOrigem: false,
  };

  constructor(
    @Inject(Router) private route,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public regraFreteService: RegraFreteService
  ) {
    this.formulario = this.formBuilder.group({
      nome: [null, Validators.required],
      modalidade: ["TODAS"],
      descricao: [null],
      dataInicial: [new Date(), Validators.required],
      dataFinal: [null],
      vigencia: [false],
      faixaCep: [false],
      estados: [false],
      faixaCepOrigem: [false],
      estadosOrigem: [false],
      valorCarrinho: [false],
      faixaPeso: [false],
      faixaPesoCubado: [false],
      acao: [null, Validators.required],
      valorAcao: [null],
      condicao: [],
    });
  }

  public ngOnInit() {}

  public toggleVigencia(event: MatSlideToggleChange) {
    this.formulario.get("dataFinal").enable();
    this.formulario.get("dataFinal").setValidators(Validators.required);

    if (event.checked) {
      this.formulario.get("dataFinal").disable();
      this.formulario.get("dataFinal").setValidators(null);
    }
  }

  public verificarTipoAcao(event) {
    const acao: any = find(this.acoes, {
      nome: event.source.selected.viewValue,
    });

    if (acao.value === "ALTERA_PERCENTUAL") {
      this.calculoPercentual = acao.tipo;
    }

    if (acao.value === "ALTERA_VALOR_FIXO") {
      this.calculoValorFixo = acao.tipo;
    }

    this.formulario.get("valorAcao").setValidators(null);
    this.formulario.get("valorAcao").setValue(null);
    this.necessitaPreencher = false;

    if (acao.obrigatorio) {
      this.formulario.get("valorAcao").setValidators(Validators.required);
      this.necessitaPreencher = true;
    }

    switch (acao.value) {
      case "ALTERA_PRAZO":
        this.labelValorAcao = "Dias";
        this.mascara = null;
        break;
      case "ALTERA_PERCENTUAL":
        this.labelValorAcao = "Percentual";
        this.mascara = "percent";
        break;
      default:
        this.labelValorAcao = "Valor";
        this.mascara = null;
    }
  }

  public formData(value) {
    return this.formulario.get(value).value;
  }

  public responseEventEmitter(condicao) {
    const { tipo, valor } = condicao;

    this.condicoesErro[tipo] = condicao.error;

    if (condicao.error) {
      return;
    }

    const data = {
      [tipo]: valor,
    };

    Object.assign(this.condicoes, data);
  }

  public enviar() {
    if (this.formulario.valid) {
      const checar = this.checarCondicoes();
      if (!checar) {
        this.criarRegra();
      }
    }
  }

  public async criarRegra() {
    try {
      if (this.formulario.valid) {
        const data = {
          dataInicial: moment(this.formData("dataInicial")).format(
            "YYYY-MM-DD"
          ),
          dataFinal: this.formData("dataFinal")
            ? moment(this.formData("dataFinal")).format("YYYY-MM-DD")
            : null,
          ativa: true,
          nome: this.removerCaracteres(this.formData("nome")),
          descricao: this.formData("descricao")
            ? this.removerCaracteres(this.formData("descricao"))
            : null,
          modalidades:
            this.formData("modalidade") === "TODAS"
              ? ["ECONOMICO", "RAPIDO"]
              : [this.formData("modalidade")],
          acao: {
            nome: this.formData("acao"),
          },
          condicoes: this.condicoes,
        };

        const exigeValor = [
          "ALTERA_PERCENTUAL",
          "FIXA_VALOR",
          "ALTERA_PRAZO",
          "ALTERA_VALOR_FIXO",
        ];
        if (exigeValor.includes(this.formData("acao"))) {
          Object.assign(data.acao, { valor: this.formData("valorAcao") });

          if (this.formData("acao") === "ALTERA_PERCENTUAL") {
            let valor = 1 + this.formData("valorAcao") / 100;

            if (this.calculoPercentual === "negativo") {
              const calculo = parseInt(this.formData("valorAcao"), 10) / 100;
              valor = parseFloat((1 - calculo).toFixed(2));
            }

            Object.assign(data.acao, { valor: valor });
          }

          if (this.formData("acao") === "ALTERA_VALOR_FIXO") {
            Object.assign(data.acao, {
              valor:
                this.calculoValorFixo === "negativo"
                  ? -this.formData("valorAcao")
                  : this.formData("valorAcao"),
            });
          }
        }

        const response = await this.regraFreteService.criarRegra(data);

        this.definirOrdem(response.id);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  public checarCondicoes() {
    let aviso = {};

    if (
      this.formData("acao") === "ALTERA_PRAZO" &&
      this.formData("valorAcao") > 3
    ) {
      aviso = {
        mensagem: `A regra consiste em adicionar ${this.formData(
          "valorAcao"
        )} dias ao prazo`,
      };

      this.openDialog(aviso);

      return true;
    }

    if (
      this.formData("acao") === "EXCLUIR_MODALIDADE" &&
      this.formData("valorAcao") === "todas"
    ) {
      aviso = {
        mensagem: `A regra irá remover todas as modalidades do leilão`,
      };

      this.openDialog(aviso);

      return true;
    }

    if (
      this.formData("acao") === "FIXA_VALOR" &&
      this.formData("valorAcao") > 30
    ) {
      aviso = {
        mensagem: `A regra irá fixar o frete em R$${this.formData(
          "valorAcao"
        )}`,
      };

      this.openDialog(aviso);

      return true;
    }

    if (
      this.formData("acao") === "ALTERA_VALOR_FIXO" &&
      this.formData("valorAcao") > 20
    ) {

      const tipoAcao = this.calculoValorFixo === "negativo" ? "subtrair" : "adicionar";

      aviso = {
        mensagem: `A regra irá ${tipoAcao} R$ ${this.formData(
          "valorAcao"
        )} ao frete`,
      };

      this.openDialog(aviso);

      return true;
    }

    if (
      this.formData("acao") === "ALTERA_PERCENTUAL" &&
      this.formData("valorAcao") === 0
    ) {
      aviso = {
        mensagem: `A regra irá adicionar ou descontar ${this.formData(
          "valorAcao"
        )}% ao frete`,
      };

      this.openDialog(aviso);

      return true;
    }

    if (
      this.formData("acao") === "ALTERA_PERCENTUAL" &&
      this.formData("valorAcao") > 10
    ) {
      let msg = `A regra irá adicionar ${this.formData("valorAcao")}% ao frete`;

      if (this.calculoPercentual === "negativo") {
        msg = `A regra irá subtrair ${this.formData("valorAcao")}% do frete`;
      }

      aviso = {
        mensagem: msg,
      };

      aviso = {
        mensagem: msg,
      };

      this.openDialog(aviso);

      return true;
    }

    if (this.formulario.get("faixaCep").value) {
      if (
        !this.condicoes["faixasCep"] ||
        this.condicoes["faixasCep"].length === 0
      ) {
        aviso = {
          mensagem: `A regra Faixa CEP (Destino) está habilitada mas não há valores inseridos.`,
        };

        this.openDialog(aviso, true);

        return true;
      }
    }

    if (this.formulario.get("faixaCepOrigem").value) {

      console.log("faixasCepOrigem");
      console.log(this.condicoes["faixasCepOrigem"]);
      console.log("faixasCep");
      console.log(this.condicoes["faixasCep"]);

      if (
        !this.condicoes["faixasCepOrigem"] ||
        this.condicoes["faixasCepOrigem"].length === 0
      ) {
        aviso = {
          mensagem: `A regra Faixa CEP (Origem) está habilitada mas não há valores inseridos.`,
        };

        this.openDialog(aviso, true);

        return true;
      }
    }

    if (Object.keys(this.condicoes).length === 0) {
      aviso = {
        mensagem: `A regra não possui condições`,
      };

      this.openDialog(aviso, true);

      return true;
    }

    if (this.formulario.get("estados").value) {
      if (
        !this.condicoes["estados"] ||
        this.condicoes["estados"].length === 0
      ) {
        aviso = {
          mensagem: `A regra de Estados Destino está habilitada mas não há valores inseridos.`,
        };

        this.openDialog(aviso, true);

        return true;
      }
    }

    if (this.formulario.get("estadosOrigem").value) {
      if (
        !this.condicoes["estadosOrigem"] ||
        this.condicoes["estadosOrigem"].length === 0
      ) {
        aviso = {
          mensagem: `A regra de Estados Origem está habilitada mas não há valores inseridos.`,
        };

        this.openDialog(aviso, true);

        return true;
      }
    }

    if (this.condicoes.hasOwnProperty("faixaCep")) {
      if (this.condicoes["faixasCep"].length > 2) {
        aviso = {
          mensagem: `A regra possui ${this.condicoes["faixasCep"].length} sobreposições de faixa de cep destino`,
        };

        this.openDialog(aviso);

        return true;
      }
    }

    if (this.condicoes.hasOwnProperty("faixaCepOrigem")) {
      if (this.condicoes["faixasCepOrigem"].length > 2) {
        aviso = {
          mensagem: `A regra possui ${this.condicoes["faixasCep"].length} sobreposições de faixa de cep origem`,
        };

        this.openDialog(aviso);

        return true;
      }
    }

    return false;
  }

  public async definirNovaOrdem(ordem) {
    try {
      await this.regraFreteService.novaOrdem(ordem);

      const dialogRef = this.dialog.open(ModalConfirmComponent, {
        disableClose: true,
        width: "450px",
        data: {
          texto: `Regra criada com sucesso`,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.route.navigate(["/configuracoes-do-usuario/regra-frete"]);
      });

      sessionStorage.removeItem("mandae-regra-item");
    } catch (error) {
      console.log(error);
    }
  }

  public changeCondicao(evento, condicao) {
    if (evento.checked === false) {
      delete this.condicoes[condicao];
      this.condicoesErro[condicao] = false;
    }
  }

  public permiteSalvarRegra() {
    for (const i in this.condicoesErro) {
      if (this.condicoesErro[i]) {
        return false;
      }
    }
    return true;
  }

  public cancelar() {
    const response = confirm(
      "Ao cancelar, todas as alterações serão perdidas, deseja continuar?"
    );

    if (response) {
      this.route.navigate(["/configuracoes-do-usuario/regra-frete"]);
    }
  }

  private openDialog(aviso, notificacao?) {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: "450px",
      data: {
        texto: !notificacao
          ? `${aviso.mensagem}. Deseja continuar?`
          : aviso.mensagem,
        notificacao,
        action: {
          cancel: notificacao ? false : "Não",
          confirm: notificacao ? "Continue editando" : "Salvar regra",
        },
      },
    });

    if (!notificacao) {
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.criarRegra();
        }
      });
    }
  }

  private definirOrdem(novoId) {
    try {
      const ordem = JSON.parse(sessionStorage.getItem("mandae-regra-frete"));

      ordem.push(novoId);

      this.definirNovaOrdem(ordem);
    } catch (error) {}
  }

  private removerCaracteres(text) {
    return text.replace(/[;]|\n/g, "");
  }
}
